import script from "./TimelineStepDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimelineStepDescription.vue?vue&type=script&setup=true&lang=ts"

import "./TimelineStepDescription.vue?vue&type=style&index=0&id=b460aca6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b460aca6"]])

export default __exports__